import React from 'react'

import styled from 'styled-components'

import { CircularProgress } from '../CircularProgress'
import { Fade } from '../Fade'
import type { ButtonProps } from './Button'
import { Button } from './Button'
import { BUTTON_SIZE, ICON_SIZE } from './constant'

import { AsyncButtonLoadingStyles, LoadingIndicatorDiv, setLoadingColorsStyles } from './styles'

const StyledButton = styled(Button)<{ $loading: boolean }>`
  ${setLoadingColorsStyles}
  ${AsyncButtonLoadingStyles}
`

export interface AsyncButtonProps extends ButtonProps {
  loading: boolean
}

export const AsyncButton = React.forwardRef<HTMLButtonElement, AsyncButtonProps>(
  ({ loading, children, disabled, ...props }, ref) => {
    return (
      <StyledButton $loading={loading} disabled={disabled || loading} ref={ref} {...props}>
        <>
          <Fade in={loading} mountOnEnter unmountOnExit>
            <LoadingIndicatorDiv>
              <CircularProgress size={ICON_SIZE[props.size ?? BUTTON_SIZE.NORMAL]} color="inherit" />
            </LoadingIndicatorDiv>
          </Fade>
          <div>{children}</div>
        </>
      </StyledButton>
    )
  }
)

AsyncButton.displayName = 'AsyncButton'
